// @flow

import * as React from 'react';

import { Badge, Base, Interactive, Text } from '@gandi/ui';

import type { Suggestion } from '../types';
import Breadcrumb from './Breadcrumb';
import styles from './SearchResult.scss';

type Props = {|
  selected: boolean,
  suggestion: Suggestion,
  onClick: (rank: number) => void,
|};

function SearchResult({ selected, suggestion, onClick }: Props) {
  const selectedProps = selected
    ? {
        borderColor: 'green-dark',
        backgroundColor: 'grey-light',
        highlight: 'green',
      }
    : {
        borderColor: 'grey-light',
        backgroundColor: 'white',
      };

  return (
    <Interactive
      flex
      flexRow
      padding="small"
      hoverable
      hoverHighlight="green"
      hoverBorderColor="green-dark"
      hoverBackgroundColor="grey-light"
      href={suggestion.url}
      target="_blank"
      rel="noopener"
      onClick={() => onClick(suggestion.rank)}
      {...selectedProps}
    >
      <Base flex flexCol flexGrow1>
        <Base tagName="h1" size="base" weight="semibold" marginBottom="xsmall">
          <Text color="base">{suggestion.title}</Text>
        </Base>

        <Base tagName="p" size="small" color="light" margin="none">
          {/* NOTE: the last value contains the document title which is not
              relevant. */}
          <Breadcrumb path={suggestion.breadcrumb.slice(0, -1)} />
        </Base>
      </Base>

      <Base flex flexJustifyEnd flexAlignItemsCenter>
        <Badge className={styles.badge}>
          {/* NOTE: this cleaning could be done on the back-end, to return a
              human readable category string. */}
          {suggestion.category.replace(/_/g, ' ')}
        </Badge>
      </Base>
    </Interactive>
  );
}

function areEqual(prevProps: Props, nextProps: Props) {
  return (
    prevProps.suggestion.doc_id === nextProps.suggestion.doc_id &&
    prevProps.selected === nextProps.selected
  );
}

export default (React.memo(
  SearchResult,
  areEqual
): React.AbstractComponent<Props>);
